module.exports = __webpack_public_path__ + "img/avatar-10.8ad57b11.png";